import Dexie, { Table, DexieOptions } from 'dexie';
import Vue from 'vue';

// Declared inside app
export interface IndexedDBTables {}

export type IndexDBTable<TKey, T> = Table<TKey, T>;

export default class IndexedDB extends Dexie implements IndexedDBTables {
  constructor(options?: DexieOptions) {
    super(`${Vue.$version.name}.glittr.db`, options);
  }
}
